<template>
  <CockpitDialog
    class="accessRecordDialog"
    :title="`${deviceType === 2 ? '人员' : '车辆'}出入记录`"
    @close="close"
  >
    <el-table
      v-if="deviceType === 2"
      ref="tableRef"
      height="calc(100% - 50px)"
      class="mt-20px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column width="60" :label="`${$t('序号')}`" type="index"></el-table-column>
      <el-table-column :label="`${$t('人员姓名')}`" show-overflow-tooltip prop="personName">
      </el-table-column>
      <el-table-column :label="`${$t('员工号码')}`" show-overflow-tooltip prop="personCode">
      </el-table-column>
      <el-table-column :label="`${$t('设备名称')}`" show-overflow-tooltip prop="deviceName">
      </el-table-column>
      <el-table-column :label="`${$t('动作')}`" show-overflow-tooltip prop="actionType" width="100">
        <template slot-scope="scope">
          <span :class="scope.row.actionType === 1 ? 'text-red-600' : 'text-green-600'">
            {{ scope.row.actionType === 1 ? '进' : '出' }}</span
          >
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('动作时间')}`" show-overflow-tooltip prop="actionTime">
      </el-table-column>
    </el-table>
    <el-table
      v-if="deviceType === 3"
      ref="tableRef"
      height="calc(100% - 50px)"
      class="mt-20px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column width="60" :label="`${$t('序号')}`" type="index"></el-table-column>
      <el-table-column :label="`${$t('车牌号')}`" show-overflow-tooltip prop="carNumber">
      </el-table-column>
      <el-table-column :label="`${$t('设备名称')}`" show-overflow-tooltip prop="deviceName">
      </el-table-column>
      <el-table-column :label="`${$t('设备编码')}`" show-overflow-tooltip prop="deviceCode">
      </el-table-column>
      <el-table-column :label="`${$t('动作')}`" show-overflow-tooltip prop="actionType" width="100">
        <template slot-scope="scope">
          <span :class="scope.row.actionType === 1 ? 'text-red-600' : 'text-green-600'">
            {{ scope.row.actionType === 1 ? '进' : '出' }}</span
          >
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('动作时间')}`" show-overflow-tooltip prop="actionTime">
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="total"
      :current-page.sync="pageNo"
      :page-size.sync="pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="getAccessControlOrBarrierGateDetail()"
      :pager-count="5"
    >
    </el-pagination>
  </CockpitDialog>
</template>

<script>
import { WisdomSecurityApi } from '@wiz-api/huizhou2'

const wisdomSecurityApi = new WisdomSecurityApi()
const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}
export default {
  name: 'accessRecordDialog',
  components: {
    CockpitDialog,
  },
  props: {
    deviceId: {
      type: String,
      default: '',
    },
    deviceType: {
      type: Number,
      default: 2,
    },
  },
  watch: {
    deviceId() {
      this.getAccessControlOrBarrierGateDetail()
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNo: 1,
    }
  },
  created() {
    this.getAccessControlOrBarrierGateDetail()
  },
  methods: {
    close() {
      this.isShow = false
      this.$emit('refresh', false)
    },
    async getAccessControlOrBarrierGateDetail() {
      const [err, res] = await wisdomSecurityApi.getAccessControlOrBarrierGateDetail({
        body: {
          maxResultCount: this.pageSize,
          skipCount: (this.pageNo - 1) * this.pageSize,
          DeviceType: this.deviceType,
          DeviceId: this.deviceId,
        },
      })
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.accessRecordDialog {
  left: 520px;
  top: 200px;
}

.searchBox {
  background: linear-gradient(180deg, #042c37 0%, #072b30 100%);
  border: 1px solid #03ffec;
  input {
    background-color: transparent;
    border: none;
  }
}
.tableBox {
  height: calc(100% - 50px);
  color: rgba(255, 255, 255, 0.8);
  font-family: HarmonyOS Sans SC;
  font-size: 12px;
  text-align: center;
  .tableHeader {
    height: 36px;
    border-radius: 1px;
    background: linear-gradient(0deg, rgba(0, 116, 141, 0.43) 0%, rgba(0, 116, 153, 0) 100%),
      linear-gradient(0deg, rgba(135, 233, 255, 1) 0%, rgba(98, 156, 168, 0) 100%);
    align-items: center;
    justify-content: space-between;
  }
  .w-30 {
    width: 30%;
  }
  .w-25 {
    width: 25%;
  }
  .w-20 {
    width: 20%;
  }
  .w-5 {
    width: 5%;
  }
  .w-15 {
    width: 15%;
  }
  .w-10 {
    width: 10%;
  }
  .tableBody {
    height: 88%;
    overflow: auto;
    .tableTr {
      height: 40px;
      align-items: center;
      justify-content: space-between;
      border-radius: 1px;
      background: #183a49;
      // background: rgba(255, 255, 255, 0.04);
      // border: 1px solid rgba(255, 255, 255, 0.1);
      margin-bottom: 2px;
      cursor: pointer;
    }
  }
}
</style>
